import { Page } from '../../state';
import { PageActionType } from './page-action-type';

export interface LoadPageSuccessAction {
  page: Partial<Page>;
  pageKey: string;
  type: PageActionType.LoadPageSuccess;
}

export const loadPageSuccess = (
  pageKey: string,
  page: Partial<Page>,
): LoadPageSuccessAction => ({
  page,
  pageKey,
  type: PageActionType.LoadPageSuccess,
});
